module.exports = __webpack_public_path__ + "static/media/sliceOfLife.83f6baab.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/UI/musicButton/song/sliceOfLife.mp3
// module id = 926
// module chunks = 0